"use strict";

exports.__esModule = true;
exports["default"] = void 0;
// Provides full circle to better represent progress
var circleBackgroundPlugin = {
  id: "circleBackground",
  beforeDraw: function beforeDraw(chart, args, options) {
    var ctx = chart.ctx,
        _chart$chartArea = chart.chartArea,
        right = _chart$chartArea.right,
        bottom = _chart$chartArea.bottom;
    var bgColor = options.bgColor,
        thicknessPercentage = options.thicknessPercentage;
    var lineWidth = right / 100 * (100 - thicknessPercentage) / 2;
    ctx.save();
    ctx.lineWidth = lineWidth;
    ctx.strokeStyle = bgColor;
    ctx.beginPath();
    ctx.arc(right / 2, bottom / 2, right / 2 - lineWidth / 2, 0, 2 * Math.PI);
    ctx.stroke();
    ctx.restore();
  }
};
var _default = circleBackgroundPlugin;
exports["default"] = _default;